import React from 'react';

export const Label = ({
  title,
  bgColor = 'green',
  textColor = 'white',
  borderRadius = 6,
  showIcon = false,
  pos = 'right',
  icon,
  iconSize = '0.7em',
  padding = '0.2rem 1rem',
  fontWeight = 'normal',
  fontSize = 12,
  className = '',
}) => {
  if (!title) return null;
  return (
    <span
      className={`label ${className} tw-whitespace-nowrap tw-capitalize`}
      style={{
        background: bgColor,
        color: textColor,
        fontSize: fontSize,
        borderRadius: borderRadius,
        padding: padding,
        lineHeight: 'normal',
        display: 'inline-flex',
        alignItems: 'center',
        fontWeight: fontWeight,
      }}
    >
      {showIcon && pos === 'left' && (
        <img
          style={{
            width: iconSize,
            marginRight: '0.4em',
          }}
          alt=''
          src={icon}
        />
      )}
      {title}
      {showIcon && pos === 'right' && (
        <img
          style={{
            width: iconSize,
            marginLeft: '0.4em',
          }}
          alt=''
          src={icon}
        />
      )}
    </span>
  );
};
